module.exports = __webpack_public_path__ + "img/arrow_back-24px.8a6294af.svg";